import {
  branch,
  compose,
  lifecycle,
  renderNothing,
  withHandlers
} from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { flashNotification } from 'src/actions'
import { toggleSubscription } from 'src/actions/home'
import { SUBSCRIPTIONS } from 'src/constants/messages'
import {
  selectIsUnsubscribed,
  selectHasHomeData
} from 'src/store/selectors/home'
import { selectHomeUnsubscribeRequested } from 'src/store/selectors/home/unsubscribe'

const SubscriptionContainer = compose(
  injectIntl,
  connect(
    state => ({
      hasSubscriptionInfo: selectHasHomeData(state),
      isSubscribed: !selectIsUnsubscribed(state),
      shouldUnsubscribe: selectHomeUnsubscribeRequested(state),
      isBuyer: false
    }),
    dispatch => ({
      notify: message =>
        dispatch(flashNotification({ message, messageType: 'error' })),
      toggleSubscription: ({ onSuccess, onError }) =>
        dispatch(toggleSubscription({ onSuccess, onError }))
    })
  ),
  withHandlers({
    onSubmit: ({
      intl,
      isSubscribed,
      notify,
      toggleSubscription
    }) => async e => {
      if (e) {
        e.preventDefault()
      }

      toggleSubscription({
        onSuccess: () =>
          notify(
            isSubscribed
              ? intl.formatMessage(SUBSCRIPTIONS.notificationUnsubscribed)
              : intl.formatMessage(SUBSCRIPTIONS.notificationSubscribed)
          ),
        onError: () =>
          notify(intl.formatMessage(SUBSCRIPTIONS.notificationError))
      })
    }
  }),
  branch(({ hasSubscriptionInfo }) => !hasSubscriptionInfo, renderNothing),
  lifecycle({
    componentDidMount () {
      const {
        intl,
        isSubscribed,
        notify,
        onSubmit,
        shouldUnsubscribe
      } = this.props

      if (!shouldUnsubscribe) {
        return
      }

      if (isSubscribed) {
        onSubmit()
      } else {
        notify(intl.formatMessage(SUBSCRIPTIONS.notificationUnsubscribed))
      }
    }
  })
)

export default SubscriptionContainer
